export default __webpack_public_path__ + "static/media/dev-box-preview-win11_dark.0a7c0800.jpg";